



















































import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import DataSource from 'devextreme/data/data_source';
import { alert } from 'devextreme/ui/dialog';
import dxValidationGroup from 'devextreme/ui/validation_group';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxValidationGroup } from 'devextreme-vue/validation-group';
import { DxRequiredRule, DxValidator } from 'devextreme-vue/validator';
import { CurrencyDto } from '@/models/CurrencyDto';
import { InvoiceLookupLineItemDto } from '@/models/invoice/InvoiceLookupLineItemDto';
import { CurrencyService } from '@/service/CurrencyService';

@Component({
  components: {
    DxNumberBox,
    DxPopup,
    DxRequiredRule,
    DxSelectBox,
    DxToolbarItem,
    DxValidationGroup,
    DxValidator
  }
})
export default class ApplyExchangeRate extends Vue {
  private readonly currencyService: CurrencyService = new CurrencyService();
  private readonly targetCurrency: string = 'USD';
  private readonly title: string = 'Apply Exchange Rate';
  private currencies: CurrencyDto[] = [];
  private showDialog: boolean = false;
  private validationGroup: dxValidationGroup | undefined;

  public dialogResult: boolean | null = null;
  public invoiceDate: Date | null = null;
  public lineItem: InvoiceLookupLineItemDto | null = null;
  public value: number | null = null;

  private get okButtonOptions() {
    return {
      text: 'OK',
      type: 'default',
      stylingMode: 'contained',
      onClick: this.ok
    };
  }

  private get cancelButtonOptions() {
    return {
      text: 'Cancel',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.cancel
    };
  }

  private get currenciesDataSource() {
    return new DataSource({
      store: this.currencies,
      paginate: true,
      pageSize: 100
    });
  }

  async created() {
    await this.loadData();
  }

  private async loadData() {
    this.currencies = await this.currencyService.getAll();
  }

  public show() {
    this.showDialog = true;
  }

  private async onCurrencyChanged(e: any) {
    if (this.invoiceDate == null) {
      return;
    }

    this.value = null;
    
    if (e.event == null || e.value == null) {
      return;
    }

    let source = e.value as string;
    await this.currencyService.getHistoricalExchangeRate(source, this.targetCurrency, this.invoiceDate)
      .then(result => {
        this.value = result.ExchangeRate;
      })
      .catch(() => {
        alert('An error occurred retrieving the exchange rate.', 'Error');
      });
  }

  private ok() {
    if (this.isValid()) {
      this.close(true);
    }
  }

  private isValid() {
    if (this.validationGroup == null) {
      return true;
    }

    let result = this.validationGroup.validate();
    return result.isValid === true;
  }

  private cancel() {
    this.close(false);
  }

  private close(dialogResult: boolean) {
    this.dialogResult = dialogResult;
    this.showDialog = false;
  }

  private resetValidators() {
    if (this.validationGroup != null) {
      this.validationGroup.reset();
    }
  }

  private onShowing() {
    this.dialogResult = null;
    this.value = null;
    this.resetValidators();
  }

  @Emit('hiding')
  private onHiding() {
    return this.dialogResult;
  }

  private onValidationGroupInitialized(e: any) {
    this.validationGroup = e.component;
  }
}
